import Header from 'notifications_historic/components/list/NotificationsHistoricListHeader';
import Filters from 'notifications_historic/components/list/NotificationsHistoricListFilters';
import Table from 'notifications_historic/components/list/NotificationsHistoricListTable';
import Row from 'notifications_historic/components/list/NotificationsHistoricListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/notifications_historic/components/list/index.js